import { render, staticRenderFns } from "./speedPage.vue?vue&type=template&id=4116f8ee&scoped=true&"
import script from "./speedPage.vue?vue&type=script&lang=js&"
export * from "./speedPage.vue?vue&type=script&lang=js&"
import style0 from "./speedPage.vue?vue&type=style&index=0&id=4116f8ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4116f8ee",
  null
  
)

export default component.exports